
import React from 'react';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view';

class JsonViewer extends React.PureComponent {
    static propTypes = {
        src: PropTypes.object.isRequired,
        name: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.oneOf([null, false])
        ]),
        collapsed: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.bool
        ]),
        displayDataTypes: PropTypes.bool
    };

    static defaultProps = {
        name: false,
        collapsed: false
    };

    render() {
        const style = {
            wordBreak: 'break-all'
        };

        return (
            <ReactJson
                style={style}
                {...this.props}
            />
        );
    }
}

export default JsonViewer;
